export const ADD_FREE_GIFT_TO_CART_ENDPOINT = '/OsimCart/UpdateFreeGiftPopup';
